import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import SelfPacedLearning from "./SelfPacedLearning";
import "../HomePage.css";

const IntroSection = ({
  userData,
  primaryText,
  typewriterStrings,
  tertiaryText,
  quaternaryText,
  buttonText,
  onButtonClick,
}) => {
  const [offsetY, setOffsetY] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    if (onButtonClick) onButtonClick();
  };
  const closeModal = () => setIsModalOpen(false);

  const handleScroll = () => {
    setOffsetY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section
      className="intro-section"
    >
      <motion.div
        className="intro-text primary"
        style={{ transform: `translateY(${offsetY * 0.3}px)` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        {primaryText}
      </motion.div>

      <motion.div
        className="intro-text secondary"
        style={{ transform: `translateY(${offsetY * 0.5}px)` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        <Typewriter
          options={{
            strings: typewriterStrings,
            autoStart: true,
            loop: true,
            delay: 75,
            deleteSpeed: 20,
            pauseFor: 1500,
          }}
        />
      </motion.div>

      <motion.div
        className="intro-text tertiary"
        style={{ transform: `translateY(${offsetY * 0.7}px)` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        {tertiaryText}
      </motion.div>

      <motion.div
        className="intro-text quaternary"
        style={{ transform: `translateY(${offsetY * 0.9}px)` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        {quaternaryText}
      </motion.div>

      {(userData && userData.role === "users" || userData === null) &&
        <motion.button
          className="cta-button"
          style={{ transform: `translateY(${offsetY * 1.1}px)` }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={openModal}
        >
          {buttonText}
        </motion.button>
      }

      <SelfPacedLearning isOpen={isModalOpen} closeModel={closeModal} />
    </section>
  );
};

export default IntroSection;
